import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AlertColor } from '@mui/material/Alert/Alert';

export interface SnackbarState {
  open: boolean;
  autoHideDuration?: number;
  message?: string;
  severity?: AlertColor;
  detailedMessage?: string;
}

const initialSnackbarState: SnackbarState = {
  open: false,
};

const SnackbarSlice = createSlice({
  name: 'Snackbar',
  initialState: initialSnackbarState,
  reducers: {
    openSnackbar(state, action: PayloadAction<Omit<SnackbarState, 'open'>>): void {
      state.open = true;
      state.autoHideDuration = action.payload.autoHideDuration;
      state.message = action.payload.message;
      state.detailedMessage = action.payload.detailedMessage;
      state.severity = action.payload.severity;
    },
    closeSnackbar(state): void {
      state.open = false;
    },
  },
});

export default SnackbarSlice.reducer;
export const snackbarActions = SnackbarSlice.actions;
